import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthPanelHeader from './authHeader';
import BasicPanel from '../../components/panels/basicPanel/basicPanel';
import { formatPhoneNumber } from '../createInvoice/steps/utils/phoneFormatter';
import { useMessenger } from '../../context/messengerContext';
import PhoneInputField from '../../components/inputs/phoneInput/phoneInput';
import validateForm from './validators/validatorHelper';
import { callback_less } from '../../api/auth';

import Btn from '../../components/Btn/Btn';
import './authpanel.css';
import BasicInput from '../../components/inputs/basicInput/basicInput';
import PhoneInput from 'react-phone-input-2';
import { Loader, Message, useToaster } from 'rsuite';
import { useTranslation } from 'react-i18next';
import { subscribeToPush } from '../../utils/pushSubscription';

export default function AuthContact() {
    const { t } = useTranslation('basic');
    const { userId, platform } = useMessenger();
    const { state } = useLocation();
    const navigator = useNavigate();

    const [startTime, setStartTime] = useState(new Date());
    const [errors, setErrors] = useState({});

    const searchParams = new URLSearchParams(window.location.search);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);

    const { _login, password, contract_number: stateContract, first: stateFirst, access_token, language: stateLanguage } = state || {};
    const searchContractNumber = searchParams.get('contract_number');
    const searchLanguage = searchParams.get('lang');
    const searchFirst = searchParams.get('first');

    const contract_number = stateContract || searchContractNumber;
    const first = stateFirst || searchFirst;
    const language = stateLanguage || searchLanguage || 'ru';

    const toaster = useToaster();

    return (
        <div className='authPanelWrapper'>
            <AuthPanelHeader
                backButton
                backButtonCallback={() =>
                    navigator(`/auth?first=${first}`, {
                        state: {
                            userId,
                            _login,
                            password,
                            contract_number,
                            first,
                        },
                    })
                }
            />
            <BasicPanel className='authPanel'>
                <div className='authRows'>
                    <h2 className='heading-h4'>{t('contact_information')}</h2>
                    <BasicInput
                        error={errors?.firstName}
                        placeholder={t('first_name')}
                        value={firstName}
                        onChange={(value) => setFirstName(value)}
                    />

                    <BasicInput
                        error={errors?.lastName}
                        placeholder={t('last_name')}
                        value={lastName}
                        onChange={(value) => setLastName(value)}
                    />

                    <BasicInput
                        error={errors?.middleName}
                        placeholder={t('middle_name')}
                        value={middleName}
                        onChange={(value) => setMiddleName(value)}
                    />

                    <PhoneInputField
                        defaultCountry='ru'
                        error={errors?.phone}
                        placeholder={t('phone')}
                        onChange={(value) => {
                            console.log(value);
                            setPhone(value);
                        }}
                    />

                    <Btn
                        text={!loading ? t('login') : <Loader size='xs' />}
                        disabled={loading}
                        width='100%'
                        className='authSubmitButton'
                        onClick={async () => {
                            setLoading(true);
                            let errors = validateForm(1, {
                                firstName,
                                lastName,
                                middleName,
                                phone,
                            });

                            if (Object.keys(errors).length) {
                                console.log(errors);
                                setErrors(errors);

                                // Показать уведомление об ошибке
                                toaster.push(
                                    <Message type='error' showIcon>
                                        {t('not_all_fields_filled')}
                                    </Message>,
                                    { placement: 'topCenter', duration: 3000 },
                                );

                                setLoading(false);
                                return;
                            }

                            if (first) {
                                  await callback_less({
                                    platform,
                                    userId,
                                    access_token: access_token || '',
                                    contract_number: contract_number,
                                    language: language,
                                    first: first,
                                    first_name: firstName,
                                    middle_name: middleName,
                                    last_name: lastName,
                                    phone: phone,
                                    session: {
                                        start_time: startTime.toISOString(),
                                        total_time:
                                            new Date().getTime() -
                                            startTime.getTime(),
                                    },
                                    }).then(() => {
                                    subscribeToPush(platform, userId);
                                    sessionStorage.clear();
                                    navigator('/menu');
                                });
                                return;
                            }

                            await callback_less({
                                platform,
                                userId,
                                access_token: access_token,
                                contract_number: contract_number,
                                language: language,
                                first: first,
                                session: {
                                    start_time: startTime.toISOString(),
                                    total_time:
                                        new Date().getTime() -
                                        startTime.getTime(),
                                },
                                first_name: firstName,
                                middle_name: middleName,
                                last_name: lastName,
                                phone: phone,
                            }).then(() => {
                                    subscribeToPush(platform, userId);
                                    sessionStorage.clear();
                                    navigator('/menu');
                            });
                        }}
                    />
                </div>
            </BasicPanel>
        </div>
    );
}
